// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const I18nProvider = registerClientReference(
    function() { throw new Error("Attempted to call I18nProvider() from the server but I18nProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/lib/i18n/client.tsx <module evaluation>",
    "I18nProvider",
);
export const useI18n = registerClientReference(
    function() { throw new Error("Attempted to call useI18n() from the server but useI18n is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/lib/i18n/client.tsx <module evaluation>",
    "useI18n",
);
